import {
  createContext,
  type FC,
  type PropsWithChildren,
  useCallback,
  useContext,
  useState,
} from "react";

type UnitsContextValue = {
  units: string;
  setUnits: (units: string) => void;
};

const UnitsContext = createContext<UnitsContextValue | undefined>(undefined);

export const UnitsProvider: FC<PropsWithChildren> = ({children}) => {
  const [units, setUnitsState] = useState("");

  const setUnits = useCallback((value: string) => {
    setUnitsState(value);
  }, []);

  return (
    <UnitsContext.Provider value={{units, setUnits}}>
      {children}
    </UnitsContext.Provider>
  );
};

export const useUnitsContext = () => {
  const ctx = useContext(UnitsContext);
  if (!ctx) {
    throw new Error("useUnits must be used within UnitsProvider");
  }
  return ctx;
};
